import Pricing from '../components/pricing'

window.version = 1.1

window.mountedComponents = []

const domReady = function() {
  I18n.locale = document.documentElement.lang

  // Pricing
  const pricingElements = document.querySelectorAll('.react-pricing')
  pricingElements.forEach( element => {
    let component = ReactDOM.render(
      React.createElement(Pricing, JSON.parse(element.dataset.props)),
      element
    )
    window.mountedComponents.push(component)
  })

}

const unmountComponents = () => {
  window.mountedComponents.forEach(component => {
    try {
      ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(component).parentNode)
    }
    catch(error) {
      // console.log(error)
    }
  })
}

document.addEventListener("turbolinks:load", domReady)
document.addEventListener('turbolinks:before-render', unmountComponents)
document.addEventListener('DOMContentLoaded', domReady)

var primaryScript = document.querySelector('#primary-script');
primaryScript.addEventListener('load', function() {
  if (['interactive', 'complete'].includes(document.readyState)) {
    domReady()
  }
});

if (window.primaryScriptLoaded) {
  domReady()
}


// $(window).bind('beforeunload', () => {
//   unmountComponents()
// })
